module.exports = __webpack_public_path__ + "media/nyan3.c1813702.mp3";